// Sponsor request functions (the centralized service layer; FRONTEND_RULES §9).
// Pure async over the shared client — no Redux, no React. Identity rides the client's
// X-User-Id header / Bearer token, so nothing here takes a sponsor id: the API resolves
// the sponsor from the session and rejects a participant with 403.

import { apiGet } from './client';

/**
 * GET /sponsor/overview — the signed-in sponsor plus a card per plan they administer
 * (the sponsor's plan-picker landing).
 */
export function getSponsorOverview() {
  return apiGet('/sponsor/overview');
}

/**
 * GET /sponsor/plans/{planId} — one plan's sponsor dashboard (balance by source,
 * payroll, YTD activity, holdings/models, workforce, loans, forfeitures).
 * @param {string} planId e.g. "PLAN-PENNY-401K"
 */
export function getSponsorPlan(planId) {
  return apiGet(`/sponsor/plans/${encodeURIComponent(planId)}`);
}
